<template>
  <div class="confirmed">
    <div class="container">

      <section class="content">
        <slot></slot>
        <p class="cta-container">
          <CTA :text="watchButton" href="./" />
        </p>
      </section>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from "@/components/SiteFooter.vue"
import CTA from "@/components/CTA.vue"
export default {
  name: "confirmed",
  props: [ "watchButton" ],
  components: {
    SiteFooter,
    CTA
  }
}
</script>

<style lang="scss" scoped>
  .confirmed {
    margin-top: 50px;
  }
</style>
